/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';
import {connect} from 'react-redux';

class FullLoading extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            showText: false,
            showButton: false,
            text: '',
            buttonTimer: null,
            textTimer: null,
            buttonDelay: 35000,
            nextTextDelay: 7000
        };

        this.textList = [
            'the tubes are full of garbage today',
            'the architects are still drafting',
            'the bits are breeding',
            'we\'re building the buildings as fast as we can',
            'would you prefer chicken, steak, or tofu?',
            'pay no attention to the man behind the curtain',
            'a few bits tried to escape, but we caught them',
            'would you like fries with that?',
            'the server is powered by a lemon and two electrodes',
            'we love you just the way you are',
            'testing your patience now',
            'don\'t think of purple hippos',
            'why don\'t you order a sandwich meanwhile?',
            'while the satellite moves into position',
            'the bits are flowing slowly today',
            'it\'s still faster than you could draw it',
            'waiting for Godot',
            'please do not move',
            'please count to 10',
            'doing something useful',
            'there is something on your teeth',
            'are you ready?',
            'prepare for awesomeness',
            'QUIET!!! I\'m trying to think here',
            'counting backwards from infinity',
            'deterministically simulating the future',
            'testing for perfection',
            'so, do you come here often?',
            'adjusting data for your IQ',
            'generating next funny line',
            'entertaining you while you wait',
            'adding random changes to your data',
            'you shouldn\'t have done that',
            'I\'m quite drunk, it might take a little more time'
        ];

        this.choseText = this.choseText.bind(this);
        this.showButton = this.showButton.bind(this);
        this.reloadPage = this.reloadPage.bind(this);
        this.init = this.init.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    init() {
        const {buttonDelay, nextTextDelay} = this.state;
        const buttonTimer = setInterval(this.choseText, nextTextDelay);
        this.setState({showText: true});
        const textTimer = setTimeout(this.showButton, buttonDelay);

        this.setState({buttonTimer: buttonTimer, textTimer: textTimer});
    }

    choseText() {
        this.setState({text: this.textList[Math.floor(Math.random() * this.textList.length)]});
    }

    showButton() {
        this.setState({showButton: true});
    }

    componentWillUnmount() {
        const {textTimer, buttonTimer} = this.state;

        clearInterval(textTimer);
        clearInterval(buttonTimer);
    }

    reloadPage() {
        location.reload();
    }

    render() {
        const {msg} = this.props;
        const {showText, showButton, text} = this.state;

        return (
            <div className="loading">
                <div className="loading-spinner">
                    <div className="loading-bounce"/>
                    <div className="loading-bounce"/>
                    <div className="loading-bounce"/>
                </div>
                {showText &&
                <div className="loading-text">
                    {text}
                </div>
                }
                {showButton &&
                <div className="loading-button">
                    <button onClick={this.reloadPage} className="btn btn-greenLight">
                        {msg.global.reload}
                    </button>
                </div>
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale]
}))(FullLoading);




// WEBPACK FOOTER //
// ./src/browser/components/loadings/FullLoading.js